// extracted by mini-css-extract-plugin
export var container = "_lq-0";
export var segment = "_lq-2";
export var segmentActive = "_lq-3";
export var track = "_lq-1";